import { useMemo, useState } from 'react';
import UI from '../../ui';
import { countries, TCountryCode } from 'countries-list';
import extractEntries from '../../helpers/extractKeys';
import { uniq } from 'lodash';
import React from 'react';
import useOnboardingState from './useOnboardingState';
import OnboardingMap from './OnboardingMap';
import { SelectCountries } from './VisitedCountriesStep';

const continentDict = {
  AF: 'Africa',
  AN: 'Antarctica',
  AS: 'Asia',
  EU: 'Europe',
  NA: 'North America',
  OC: 'Oceania',
  SA: 'South America',
};

const options = extractEntries(countries).map(({ key, value }) => ({ label: value.name, value: key }));
const continents = uniq(extractEntries(countries).map(({ value }) => value.continent));

const BucketlistStep: React.FC = () => {
  const [continent, setContinet] = useState(continents[0]);
  const { bCountries: selectedCountries, addBCountry: addCountry, removeBCountry: removeCountry, setBCountries: setCountries } = useOnboardingState();

  const filteredCountries = useMemo(() => extractEntries(countries).map(({ value, key }) => ({ country: value, code: key })).filter(c => c.country.continent === continent), [continent]);

  const toggleAdd: (country: TCountryCode) => void = (country) => {
    if (selectedCountries.includes(country)) {
      removeCountry(country);
    }
    else {
      addCountry(country);
    }
  };

  return (
    <UI.VerticalLayout gap={20} width="100%" overflow="scroll">
      <UI.VerticalLayout>
        <OnboardingMap />
      </UI.VerticalLayout>
      <UI.VerticalLayout gap={10}>
        <UI.VerticalLayout gap={10} width="100%">
          <UI.VerticalLayout>
            <UI.Text weight="bold" size="title">Which countries are on your bucket list?</UI.Text>
            <UI.Text>Select your top 10</UI.Text>
          </UI.VerticalLayout>
          {/* TODO: Limit selection to 10 */}
          <UI.Autocomplete
            options={options}
            label=""
            placeHolder="Add a country"
            selected={selectedCountries}
            onSelect={setCountries}
            adornment={<UI.Icon name="map" />}
          />
          <UI.Tabs options={continents.sort((a, b) => a.localeCompare(b)).map(v => ({ label: continentDict[v], value: v }))} value={continent} onChange={setContinet} />
        </UI.VerticalLayout>
      </UI.VerticalLayout>

      <SelectCountries filteredCountries={filteredCountries} selectedCountries={selectedCountries} toggleAdd={toggleAdd} />
    </UI.VerticalLayout>
  );
};

export default BucketlistStep;
